import React, { useState } from 'react';
import CheckboxMultiple from '../../atoms/CheckBoxMultiple';
import { useDispatch, useSelector } from 'react-redux';
import { setFilterCoupon } from 'ui/store/googleTagManager/actions';
import { useRouter } from '../../../hooks/useCustomRouter';
import { cleanedQueryAccessories } from '../../../helpers/utils/cleanedQueryAccessories';
import { IFilterOptions } from '../../../interface/accessories.interface';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import eventClickCouponServiceList from '../../../helpers/emarsys/coupon-service/eventClickCouponServiceList';
import { IRootState } from '../../../store';
import { BUTTON_NAME_SERVICE_COUPON } from '../../../constants/emarsys/service-coupon';
import eventClickPackageServiceList from '../../../helpers/emarsys/package-service/eventClickPackageServiceList';
import {
  BUTTON_NAME_SERVICE_PACKAGE,
  SECTION_NAME_SERVICE_PACKAGE,
} from '../../../constants/emarsys/service-package';

export interface FilterSpecialOfferProps {
  offerList: IFilterOptions;
  typeID: string;
  setTrigger: (value: boolean) => void;
  isPLPCategory?: boolean;
  impressionData?: {
    title?: string;
    carModels: string[];
    breadcrumbItems: IBreadcrumbs[];
    customerNo?: string;
    carCategory?: string;
    filterValue?: {
      search?: string;
      special_offer?: string;
      car_model?: string;
      order_by?: string;
    };
    sectionName: string;
  };
  feature?: string;
}

export default function FilterSpecialOffer({
  offerList,
  typeID,
  setTrigger,
  isPLPCategory,
  impressionData,
  feature,
}: FilterSpecialOfferProps) {
  const router = useRouter();
  const [dataCheckbox, setDataCheckbox] = useState([]);
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth);

  const handleFilterChange = (e) => {
    const { value, checked } = e.target;

    let cleanedQuery = value;
    let sort = '';

    const existingQueryParams: any = router.query;
    if (existingQueryParams?.q) {
      delete existingQueryParams.q;
    }
    const newUrl = `${new URLSearchParams(
      existingQueryParams ? existingQueryParams : ''
    ).toString()}`;

    const paramsForPLPAcc =
      typeID === 'accessories'
        ? existingQueryParams?.carModel
          ? `/${existingQueryParams.carModel}`
          : newUrl
        : '';

    if (cleanedQuery.includes('baseServicesBodyType')) {
      cleanedQuery = cleanedQuery
        .split('%3A')
        .filter(
          (param, index, array) =>
            !(param.startsWith('baseServicesBodyType') && array[index + 1]) &&
            !(array[index - 1] && array[index - 1].startsWith('baseServicesBodyType'))
        )
        .join('%3A');
    }

    if (typeID === 'accessories') {
      if (existingQueryParams?.sort) {
        delete existingQueryParams.carModel;
      }

      sort = existingQueryParams?.sort
        ? `&${new URLSearchParams(existingQueryParams || '').toString()}`
        : '';

      if (isPLPCategory) {
        cleanedQuery = cleanedQueryAccessories(cleanedQuery, 'accessoriesCategory');
      } else {
        cleanedQuery = cleanedQueryAccessories(cleanedQuery, 'carModel');
      }
    }

    if (feature === 'COUPON_SERVICE_LIST') {
      eventClickCouponServiceList(
        dispatch,
        impressionData?.carCategory,
        impressionData?.title,
        impressionData?.breadcrumbItems,
        userData?.customerNo,
        impressionData?.sectionName,
        BUTTON_NAME_SERVICE_COUPON.PENAWARAN_KHUSUS,
        {
          ...impressionData.filterValue,
          special_offer: checked && 'diskon',
        }
      );
    }

    if (feature === 'PACKAGE_SERVICE_LIST') {
      eventClickPackageServiceList(
        dispatch,
        impressionData?.carCategory,
        impressionData?.title,
        impressionData?.breadcrumbItems,
        userData?.customerNo,
        SECTION_NAME_SERVICE_PACKAGE.FILTER,
        BUTTON_NAME_SERVICE_PACKAGE.PENAWARAN_KHUSUS,
        impressionData?.carModels,
        {
          ...impressionData.filterValue,
          special_offer: checked && 'diskon',
        }
      );
    }

    if (newUrl === '') {
      router.push(
        typeID === 'accessories'
          ? `${process.env.NEXT_PUBLIC_URL}/c/aksesoris${paramsForPLPAcc}${cleanedQuery}${sort}`
          : cleanedQuery
      );
    } else {
      router.push(
        typeID === 'accessories'
          ? `${process.env.NEXT_PUBLIC_URL}/c/aksesoris${paramsForPLPAcc}${cleanedQuery}`
          : cleanedQuery + `&` + newUrl
      );
    }

    if (checked) {
      setDataCheckbox([...dataCheckbox, value]);
      dispatch(
        setFilterCoupon(value?.toLowerCase()?.includes('discount') ? 'diskon' : 'not available')
      );
    } else {
      dispatch(setFilterCoupon(false));
      setDataCheckbox(dataCheckbox.filter((e) => e !== value));
    }
  };

  return (
    <div>
      {offerList?.values?.map((item, _i) => {
        return (
          <CheckboxMultiple
            key={_i}
            label={offerList?.name === 'isDiscount' ? 'Diskon' : item?.name}
            value={
              typeID === 'package'
                ? item?.query?.url?.replace('/c/BASESERVICE', '')
                : typeID === 'accessories'
                  ? item?.query?.url?.replace('/c/aksesoris', '')
                  : item?.query?.url?.replace('/c/BASECOUPONSERVICES', '')
            }
            onChange={handleFilterChange}
            checked={item?.selected}
            setTrigger={setTrigger}
          />
        );
      })}
    </div>
  );
}
